var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.9,
    height: 85.9,
    viewBox: "0 0 79.9 85.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12854",
    "data-name": "Group 12854",
    transform: "translate(0.559 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    "data-name": "Path 3266",
    d: "M1.369,75.147A27.745,27.745,0,0,1,18,61.518l8.377-2.5a5.173,5.173,0,0,0,3.376-6.752,6.737,6.737,0,0,0-.875-1.625l-5.752-6.377A20.679,20.679,0,0,1,18,27.008l1.375-8.628a20.965,20.965,0,0,1,9-14.254A21.712,21.712,0,0,1,40.255.5,20.845,20.845,0,0,1,51.634,3.876h.125a20.937,20.937,0,0,1,9.628,15.38l1,8.252a21,21,0,0,1-5.252,16.5l-6.127,6.752a4.118,4.118,0,0,0-.875,1.625,5.219,5.219,0,0,0,3.376,6.752l8.377,2.5a27.745,27.745,0,0,1,16.63,13.629A6.908,6.908,0,0,1,72.39,85.4H7.371A6.973,6.973,0,0,1,1.369,75.147Z",
    transform: "translate(-0.525 -0.5)",
    fill: "none",
    stroke: "#5da9dd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M71.864,68.4H6.845A7.03,7.03,0,0,1,0,61.641a6.809,6.809,0,0,1,.84-3.495,27.738,27.738,0,0,1,16.63-13.628l8.377-2.5a5.143,5.143,0,0,0,3.126-2.6,5.271,5.271,0,0,0,.25-4.156,6.7,6.7,0,0,0-.875-1.625L22.6,27.262a20.522,20.522,0,0,1-4.533-8.017,21.024,21.024,0,0,1-.593-9.237L18.848,1.38c.071-.466.158-.931.258-1.38H60.475a21.818,21.818,0,0,1,.386,2.255l1,8.253a20.985,20.985,0,0,1-5.251,16.5l-6.126,6.751a4.171,4.171,0,0,0-.876,1.627,5.221,5.221,0,0,0,.246,4.1,5.144,5.144,0,0,0,3.131,2.65l8.376,2.5A27.739,27.739,0,0,1,77.99,58.272a6.951,6.951,0,0,1-.231,6.846A6.846,6.846,0,0,1,71.864,68.4Z",
    transform: "translate(0 16.5)",
    fill: "rgba(93,169,221,0.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.bcc3859ec7ab6eb1c5b4dedb626099d4.svg";
export { ForwardRef as ReactComponent };